var map = {
	"./A.png": "bd0b",
	"./B.png": "b5dc",
	"./C.png": "ba40",
	"./D.png": "c178",
	"./GVTRONICSh.png": "21bf",
	"./GVm-bg.png": "4e8b",
	"./cvlearnslide.png": "348c",
	"./gvslide1.png": "d1a1",
	"./gvtslide1.png": "8ca4",
	"./ind1.png": "52fa",
	"./ind2.png": "7fba",
	"./ind3.png": "f8b7",
	"./ind4.png": "9980",
	"./larrow.png": "4196",
	"./logo.png": "9664",
	"./mind1.png": "e1fe",
	"./mind2.png": "56c7",
	"./mind3.png": "f66a",
	"./mind4.png": "fe86",
	"./non.png": "711c",
	"./part1.png": "35e0",
	"./part2.png": "4f4d",
	"./part3.png": "4140",
	"./part4.png": "79b0",
	"./part5.png": "cdf1",
	"./rarrow.png": "57f9",
	"./slide-bg.png": "039a",
	"./smbg.png": "16a8",
	"./toggle.zip": "71bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "076e";